"use server";

import nodemailer from "nodemailer";

type ContactFormData = {
  name: string;
  email: string;
  message: string;
};

/**
 * Sends a contact form message to a specific email address
 * @param formData The contact form data
 * @returns Success status and message
 */
export async function sendContactFormEmail(formData: ContactFormData) {
  try {
    // Create a transporter using SMTP
    const transporter = nodemailer.createTransport({
      host: process.env.SMTP_SERVER_HOST,
      port: parseInt(process.env.SMTP_SERVER_PORT || "587"),
      secure: false, // Set to false for TLS - port 587
      auth: {
        user: process.env.SMTP_SERVER_USERNAME,
        pass: process.env.SMTP_SERVER_PASSWORD,
      },
      tls: {
        // Do not fail on invalid certs
        rejectUnauthorized: false,
        // Force TLSv1.2 only
        minVersion: "TLSv1.2",
      },
    });

    // Target email address
    const targetEmail = process.env.SMTP_SERVER_TARGET_EMAIL;

    // Email content
    const mailOptions = {
      from: `"${formData.name}" <${
        process.env.SMTP_SERVER_USERNAME || "arbogen@emergen-bioinfo.fr"
      }>`, // Use verified sender with user's name
      to: targetEmail,
      replyTo: formData.email, // Set reply-to as the user's email
      subject: `Contact Form Submission from ${formData.name} <${formData.email}>`,
      text: `
        Name: ${formData.name}
        Email: ${formData.email}
        
        Message:
        ${formData.message}
      `,
      html: `
        <h2>Arbogen - New Contact Form Submission</h2>
        <p><strong>Name:</strong> ${formData.name}</p>
        <p><strong>Email:</strong> ${formData.email}</p>
        <h3>Message:</h3>
        <p>${formData.message.replace(/\n/g, "<br>")}</p>
      `,
    };

    // Send the email
    const info = await transporter.sendMail(mailOptions);
    console.log("Email sent:", info.messageId);

    return {
      success: true,
      message: "Your message has been sent successfully.",
    };
  } catch (error) {
    console.error("Error sending contact form email:", error);
    return {
      success: false,
      message:
        "An error occurred while sending your message. Please try again later.",
    };
  }
}
